import React from 'react';
import HistoryItem from '../../../Das/Manage/History/Item';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import defaultStyles from './Default.scss';
export var DasInfo = function (_a) {
    var _b, _c, _d, _e;
    var deviation = _a.deviation;
    var hasDas = useFlag('digital_assets');
    if (!hasDas) {
        return null;
    }
    return (React.createElement("div", { className: defaultStyles['subject'] },
        React.createElement("div", { className: defaultStyles['detail-group-title'] }, "Digital Asset History"),
        ((_c = (_b = deviation.asset) === null || _b === void 0 ? void 0 : _b.history) === null || _c === void 0 ? void 0 : _c.entries) && (React.createElement("div", { role: "list" }, (_e = (_d = deviation.asset) === null || _d === void 0 ? void 0 : _d.history) === null || _e === void 0 ? void 0 : _e.entries.map(function (item) { return (React.createElement(HistoryItem, { key: item.txId, item: item })); })))));
};
DasInfo.displayName = 'DasInfo';
export default DasInfo;
//# sourceMappingURL=DasInfo.js.map